export default "__VITE_ASSET__b1TXoh02__"